export const FOLDERS = [
  { key: "games", title: "Games" },
  { key: "entertainment", title: "Entertainment" },
  { key: "health", title: "Health" },
  // { key: "shopping", title: "Shopping" },
  { key: "education", title: "Education" },
  // { key: "business", title: "Business" },
];
